'use client';

import { Fragment } from 'react';

import { IResolvedCustomComponent } from '@/src/utils/collections/custom-component.mapper';
import { CustomComponentTitle } from '@/src/components/custom-component/CustomComponentTitle';
import { CustomComponentText } from '@/src/components/custom-component/CustomComponentText';
import { CustomComponentImage } from '@/src/components/custom-component/CustomComponentImage';
import { CustomComponentVerticalSpacer } from '@/src/components/custom-component/CustomComponentVerticalSpacer';

export const CustomComponent = ({ items }: IResolvedCustomComponent) => {
  return (
    <div className={'mx-auto max-w-1200 px-4'}>
      {items.map((item, index) => (
        <Fragment key={item.type + '_' + index}>
          {item.type === 'title' && <CustomComponentTitle title={item.data} />}
          {item.type === 'text' && <CustomComponentText text={item.data} />}
          {item.type === 'image' && <CustomComponentImage image={item.data} />}
          {item.type === 'verticalSpacer' && (
            <CustomComponentVerticalSpacer spacing={item.data} />
          )}
        </Fragment>
      ))}
    </div>
  );
};
